import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFloor'
})
export class NumberFloorPipe implements PipeTransform {
  transform(value: any, precision: any = 0): any {
    if (this.isString(precision)) {
      precision = parseInt(precision, 0);
    }

    return this.createRound('floor')(value, precision);
  }

  private createRound(method: string) {
    // <any>Math to suppress error
    const func: any = (Math as any)[method];
    return (value: number, precision: number = 0) => {
      if (typeof value === 'string') {
        throw new TypeError('Rounding method needs a number');
      }

      if (typeof precision !== 'number' || isNaN(precision)) {
        precision = 0;
      }

      if (precision) {
        let pair = `${value}e`.split('e');
        const val = func(`${pair[0]}e` + (+pair[1] + precision));

        pair = `${val}e`.split('e');
        return +(pair[0] + 'e' + (+pair[1] - precision));
      }

      return func(value);
    };
  }

  private isString(value: any): value is string {
    return typeof value === 'string';
  }
}
